module.exports = __webpack_public_path__ + "media/assets/images/blog/agile-errors-small-9e83eb2798ee524aa52407ced5d2e1e3.jpg";